// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_3c5ZM){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_VViuk .dualColumn_1MjXP{display:flex;align-content:space-between}.nsAddressForm_VViuk .dualColumn_1MjXP .firstCol_3_blr{margin-right:20px}.optional_pB_hc{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_3c5ZM",
	"nsAddressForm": "nsAddressForm_VViuk",
	"dualColumn": "dualColumn_1MjXP",
	"firstCol": "firstCol_3_blr",
	"optional": "optional_pB_hc"
};
module.exports = exports;
